import React from 'react';
import Icon from './Icon';

const AddPlotIcon = (props) => (
    <Icon {...props}>
        <path
            d="M6 4L19 6L17 20L4 18ZM11.5 9V15M8.5 12H14.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default AddPlotIcon;
